/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum ContactMethod {
  Personal = "Personal",
  Axiom = "Axiom",
  Both = "Both",
}

export const ContactMethodDisplay: Record<ContactMethod, string> = {
  [ContactMethod.Personal]: "Personal",
  [ContactMethod.Axiom]: "Axiom",
  [ContactMethod.Both]: "Both",
};
